import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=5baa970a&scoped=true"
import script from "./roleEdit.vue?vue&type=script&lang=js"
export * from "./roleEdit.vue?vue&type=script&lang=js"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=5baa970a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa970a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5baa970a')) {
      api.createRecord('5baa970a', component.options)
    } else {
      api.reload('5baa970a', component.options)
    }
    module.hot.accept("./roleEdit.vue?vue&type=template&id=5baa970a&scoped=true", function () {
      api.rerender('5baa970a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/roleEdit.vue"
export default component.exports